export default "__VITE_ASSET__2798ace0__"